import { ReactNode } from "react";
import type { ClientProgress } from "types/Models/task";

export const PURCHASE_REQUIRED_STATUS = "Purchase Required";
export const MISSING_BASIC_INFO_STATUS = "Missing Basic Info";
export const MORE_INFO_REQUESTED_STATUS = "More Info Requested";
export const ALL_INFO_RECEIVED_STATUS = "All Info Received";
export const COMPLETED_STATUS = "Completed";
export const OVERDUE_STATUS = "Overdue";

type TaskStatus =
  | "SUBMITTED"
  | "FORM_FILING"
  | "FILING_IN_PROGRESS"
  | "UPLOAD_DOCUMENTS"
  | "W_SERIES"
  | "TASK_AMENDMENT_COMPLETED"
  | null;

export type TaxStatsTaskState = {
  uuid: string;
  name: string;
  is_final: boolean;
  type: number;
  next_state: string | null;
  state_json: Record<string, any>;
  is_state_reversible: boolean;
  is_customer_state: boolean;
  is_cpa_state: boolean;
  state_completed: string | null;
  index: number;
  order: number;
  description: string | null;
};

export type TaxStatsCurrentState = Omit<TaxStatsTaskState, "index"> & {
  new_state_id: string | null;
  show_review_modal: boolean;
  is_step_replaceable: boolean;
};

export type TaxTaskItem = {
  base_task_template: {
    uuid: string;
    title: string;
    description: string;
  };
  payment_amount?: string;
  task_uuid?: string;
  season: string;
  current_state: TaxStatsCurrentState;
  task_states: TaxStatsTaskState[];
  not_purchased?: boolean;
  entity: {
    uuid: string;
    registered_name: string;
  };
  task_template_uuid: string;
  completed_task_states: number;
  total_task_states: number;
  product_content_type_id: number;
  is_completed: boolean;
  is_action_pending: boolean;
  is_in_progress: boolean;
  client_progress: ClientProgress | null;
  has_client_progress?: boolean;
  is_on_hold: boolean;
  latest_etd?: string | null;
};

type TaskTemplate = {
  uuid: string;
  title: string;
  description: string;
};

type NotPurchasedTask = {
  base_task_template: TaskTemplate;
  task_template_uuid: string;
  payment_amount: string;
  season: string;
};

export type EntityTasks = {
  entity_uuid: string;
  entity_name: string;
  not_purchased_tasks: NotPurchasedTask[];
  not_purchased_tasks_count: number;
  payable_amount_entity_level: number;
};

export type TaskStats = {
  completed: TaxTaskItem[];
  in_progress: TaxTaskItem[];
  action_items_pending: TaxTaskItem[];
  not_purchased: TaxTaskItem[];
  entities: EntityTasks[];
  total_payable_amount_group_level: number;
};

export type DeadlineStatus =
  | typeof PURCHASE_REQUIRED_STATUS
  | typeof MISSING_BASIC_INFO_STATUS
  | typeof MORE_INFO_REQUESTED_STATUS
  | typeof ALL_INFO_RECEIVED_STATUS
  | typeof COMPLETED_STATUS
  | typeof OVERDUE_STATUS;

export type UpcomingDeadlineData = {
  deadline_name: string;
  deadline: string;
  current_state: string;
  days_till_deadline: number;
  hours_till_deadline: number;
  minutes_till_deadline: number;
  status: DeadlineStatus;
  purchased_task: string | null;
  base_task_template: {
    uuid: string;
    name: string;
    description: string;
  };
  entity: {
    uuid: string;
    registered_name: string;
  };
  season: string;
  task_template_uuid: string;
  payment_amount: string;
  product_content_type_id: number;
  is_added_to_cart: boolean;
  is_suggested_by_system: boolean;
};

export type Form1099Item = {
  count: number;
  entity_name: string;
  season: string;
  task_id: string;
};
